'use strict';

/*global app*/
/*global services*/
/*global createObjectCallBack*/

function Info() {
  this.outputService = null;
  this.inputService = null;

  this.init();
}

Info.prototype = $.extend({}, {
  constructor: 'Info',

  registerCallbacks: function registerCallbacks() {
    var _this = this;

    $('body').on('click', '.info__document', function () {
      _this.showDocumentInfo($(this).data('web_document_rid'));

      return false;
    });

    $('body').on('click', '.info__product', function () {
      _this.showProductInfo();

      return false;
    });

    $('body').on('click', '.info__completition', function () {
      _this.completition($(this).data('web_document_rid'), $(this).data('joining_symbol'), $(this).data('handling_unit'), $(this).data('area'));

      return false;
    });

    return _this;
  },

  //----------------------------------------------------------------------------

  showDocumentInfo: function showDocumentInfo(webDocumentRID) {
    var _this = this;

    _this.outputService.modal.block();
    $.get(app.path('process_document_info', { WebDocumentRID: webDocumentRID }), function (res) {
      _this.outputService.modal.unBlock();

      if (res.msg === 'SUCCESS') {
        _this.outputService.showMessage(res.data.info);
      } else {
        app.viewErrorMessage(res.error);
      }
    });

    return _this;
  },

  showProductInfo: function showProductInfo() {
    var _this = this;

    _this.outputService.modal.close();

    _this.inputService.getValue(null, function (value) {
      if (value) {
        services.get('product-info').searchProductInfo(value);
      }
    });

    return _this;
  },

  completition: function completition(webDocumentRID, joiningSymbol, handlingUnit, area) {
    var _this = this;

    _this.outputService.modal.close();

    var params = {
      callback: createObjectCallBack(_this, 'onAfterCompletition'),
      webDocumentRID: webDocumentRID,
      joiningSymbol: joiningSymbol,
      handlingUnit: handlingUnit,
      area: area,
      isAllowedOutgoingControl: false,
    };

    services.get('completion-service').mergeHandlingUnits(params);

    return _this;
  },

  onAfterCompletition: function onAfterCompletition() {
    var _this = this;

    console.log('hotovo!!!!');

    return _this;
  },

  getShowInfoHtml: function getShowInfoHtml(params) {
    var html = '';
    html += '<div class="row">';
    html +=   '<div class="col col-xs-6">';
    html +=     '<a href="#" class="info__document btn btn-info btn-lg full-width" data-web_document_rid="' + params.WebDocumentRID + '">' + app.t('document.title') + '</a>';
    html +=   '</div>';
    html +=   '<div class="col col-xs-6">';
    html +=     '<a href="#" class="info__product btn btn-info btn-lg full-width">' + app.t('article.title') + '</a>';
    html +=   '</div>';
    html += '</div>';

    /*
    if (params.DocumentType === pickingDocument) {
      html += '<div class="row offset-top-10">';
      html +=   '<div class="col col-xs-12">';
      html +=     '<a href="#" class="info__completition btn btn-info btn-lg full-width" data-web_document_rid="' + params.WebDocumentRID + '" data-joining_symbol="' + params.JoiningSymbol + '" data-handling_unit="' + params.HandlingUnit + '" data-area="' + params.Area + '">' + app.t('completion_process.title') + '</a>';
      html +=   '</div>';
      html += '</div>';
    }
    */

    return html;
  },

  showInfo: function showInfo(params) {
    var _this = this;

    var info = _this.getShowInfoHtml(params);
    _this.outputService.showMessage(info);

    return _this;
  },

  //----------------------------------------------------------------------------

  init: function init() {
    var _this = this;

    _this.outputService = services.get('output-service');
    _this.inputService = services.get('input-service');

    _this.registerCallbacks();

    return _this;
  }
});
